<template>
    <div class="d-flex min-vh-100">
      <Aside />
      <main class="flex-grow-1 bg-light">
        <div class="p-4">
          <h2 class="mb-4">Ajouter un Podcast</h2>
          <div class="card shadow-sm p-4">
            <form @submit.prevent="handleSubmit">
              <!-- Titre -->
              <div class="mb-3">
                <label for="title" class="form-label">Titre du podcast</label>
                <input
                  type="text"
                  id="title"
                  v-model="podcast.title"
                  class="form-control"
                  placeholder="Entrez le titre du podcast"
                  required
                />
              </div>
  
              <!-- Description -->
              <div class="mb-3">
                <label for="description" class="form-label">Description</label>
                <textarea
                  id="description"
                  v-model="podcast.description"
                  class="form-control"
                  placeholder="Entrez la description du podcast"
                  required
                  style="font-size: 18px; height: 150px;"
                ></textarea>
              </div>
  
              <!-- Code iframe Spotify -->
              <div class="mb-3">
                <label for="iframe_code" class="form-label">Code iframe du podcast</label>
                <textarea
                  id="iframe_code"
                  v-model="podcast.iframe_code"
                  class="form-control"
                  placeholder="Entrez le code iframe du podcast Spotify"
                  required
                  style="font-size: 18px; height: 100px;"
                ></textarea>
              </div>
  
              <!-- Catégorie -->
              <div class="mb-3">
                <label for="category" class="form-label">Catégorie</label>
                <select
                  id="category"
                  v-model="podcast.category"
                  class="form-select"
                  required
                >
                  <option value="" disabled>Choisissez une catégorie</option>
                  <option v-for="cat in categories" :key="cat" :value="cat">
                    {{ cat }}
                  </option>
                </select>
              </div>
  
              <!-- Bouton de soumission -->
              <button type="submit" class="btn btn-primary">Ajouter le podcast</button>
            </form>
          </div>
        </div>
      </main>
    </div>
  </template>
  
  <script>
  import axios from "@/api/axios.js";
  import Aside from "@/components/Aside.vue";
  import Swal from "sweetalert2"; // Import SweetAlert
  
  export default {
    components: {
      Aside,
    },
    data() {
      return {
        podcast: {
          title: "",
          description: "",
          iframe_code: "",
          category: "",
        },
        categories: [
          "Politics",
          "Science",
          "Environment",
          "Sports",
          "Culture",
          "History",
          "Art",
          "Food",
          "Business",
          "Fashion",
          "Music",
          "Gaming",
          "Automotive",
          "Space",
          "Legal",
          "Opinion",
          "Technology Reviews",
          "Startups",
          "Mental Health",
          "Travel Tips",
        ],
      };
    },
    methods: {
      // Soumission du formulaire
      handleSubmit() {
        console.log("Formulaire soumis"); // Ajoute ce log pour vérifier si le formulaire est bien soumis
  
        // Récupération du user_id depuis sessionStorage
        const userData = JSON.parse(sessionStorage.getItem("user"));
        const userId = userData ? userData.id : null;
  
        if (!userId) {
          console.log("Utilisateur non connecté.");
          Swal.fire("Erreur", "Vous devez être connecté pour ajouter un podcast.", "error");
          return;
        }
  
        // Validation des champs requis
        if (
          !this.podcast.title ||
          !this.podcast.description ||
          !this.podcast.category ||
          !this.podcast.iframe_code
        ) {
          Swal.fire("Erreur", "Tous les champs sont obligatoires.", "error");
          return;
        }
  
        // Création du FormData
        const formData = new FormData();
        formData.append("title", this.podcast.title);
        formData.append("description", this.podcast.description);
        formData.append("category", this.podcast.category);
        formData.append("iframe_code", this.podcast.iframe_code); // Code iframe
        formData.append("user_id", userId);
  
        // Envoi de la requête avec Axios
        axios
          .post("/add-podcasts", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            Swal.fire("Succès", "Podcast ajouté avec succès !", "success");
            // Réinitialisation des données du formulaire
            this.podcast = {
              title: "",
              description: "",
              iframe_code: "",
              category: "",
            };
          })
          .catch((error) => {
            // Vérifie si l'erreur contient des données spécifiques
            if (error.response && error.response.data && error.response.data.errors) {
              console.error("Erreurs de validation :", error.response.data.errors);
              Swal.fire("Erreur", "Erreur : " + JSON.stringify(error.response.data.errors), "error");
            } else {
              console.error("Erreur lors de l'ajout du podcast :", error);
              Swal.fire("Erreur", "Une erreur est survenue.", "error");
            }
          });
      },
    },
  };
  </script>
  
  <style scoped>
  /* Styles personnalisés si nécessaire */
  </style>
  